webpackJsonp([172093537669150],{

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Reducers = __webpack_require__(57);
	
	var _Reducers2 = _interopRequireDefault(_Reducers);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Reducers2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'byId'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint...'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Example usage is below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      const state = lore.store.getState();\n      const tweet = state.tweet.byId[1];\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import _ from \'lodash\';\n\n      /*\n       * addOrUpdateById()\n       *\n       * Insert a model into this reducer\'s state, or update the data for\n       * that model if it\'s already exists in state.\n       */\n\n      function addOrUpdateById(nextState, payload) {\n        const id = payload && payload.id;\n        let existingModel = null;\n\n        if (id) {\n          existingModel = nextState[id];\n          if (existingModel) {\n            nextState[id] = _.assign({}, payload, {\n              cid: existingModel.cid\n            });\n          } else {\n            nextState[id] = payload;\n          }\n        }\n        return nextState;\n      }\n\n      /*\n       * removeById()\n       *\n       * Remove a model from this reducer\'s state.\n       */\n\n      function removeById(nextState, payload) {\n        const id = payload && payload.id;\n        if (id) {\n          delete nextState[id];\n        }\n        return nextState;\n      }\n\n      export default function(modelName) {\n        return function byId(state, action) {\n          state = state || {};\n          const nextState = _.assign({}, state);\n\n          switch (action.type) {\n            case \'ADD_TWEET:\n              return addOrUpdateById(nextState, action.payload);\n\n            case \'UPDATE_TWEET:\n              return addOrUpdateById(nextState, action.payload);\n\n            case \'REMOVE_TWEET:\n              return removeById(nextState, action.payload);\n\n            case \'FETCH_TWEETS:\n              action.payload.data.forEach(function(datum) {\n                addOrUpdateById(nextState, datum);\n              });\n              return nextState;\n\n            default:\n              return nextState;\n          }\n        };\n      }\n\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-reducers-by-id-js-469ae5af8864f97012b6.js